module.exports = __webpack_public_path__ + "img/hezuohb.3536d3c6.png";